import type { Epic } from 'Flux/index.js'
import { organizationSlice } from 'Flux/Slice/Organization/OrganizationSlice.js'
import { authenticationExpiredOr } from 'Framework/Epic/AuthenticationExpired.js'
import { catchError, filter, mergeMap, of } from 'rxjs'
import type { AjaxError } from 'rxjs/ajax'

export const GetOrganizationMembersEpic: Epic = (action$, state$, { [organizationSlice.name]: organization, OrganizationRepository }) =>
  action$.pipe(
    filter(organization.getOrganizationMembersRequest.match),
    mergeMap((action) => {
      return OrganizationRepository.getOrganizationMembers({ organizationId: action.payload.organizationId }).pipe(
        mergeMap((response) =>
          of(
            organization.getOrganizationMembersSuccess({
              organizationId: action.payload.organizationId,
              members: response
            })
          )
        ),
        catchError((error: AjaxError) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(organization.getOrganizationMembersFailure({ error }))
          })
        )
      )
    })
  )
